//rule: alphabetic order
export const storageKeys = {
    FilterOrdersWithTransportProblemOnEnteringTransportManagementPage: 'FilterOrdersWithTransportProblemOnEnteringTransportManagementPage'
};